import 'intersection-observer';
import Scrollama from 'scrollama';
export const scrollToTop = (scrollToTopEl) => {
    if (!scrollToTopEl) {
        return;
    }
    const classNameEnter = 'rollInBottom';
    const classNameLeave = 'rollOutBottom';
    const classNameActive = 'active';
    const scroller = Scrollama();
    scroller.setup({
        step: '#js-header',
    })
        .onStepExit(evt => {
        if (evt.direction === 'down') {
            scrollToTopEl.classList.add(classNameActive);
            scrollToTopEl.classList.remove(classNameLeave);
            scrollToTopEl.classList.add(classNameEnter);
        }
    })
        .onStepEnter(evt => {
        if (evt.direction === 'up') {
            scrollToTopEl.classList.add(classNameActive);
            scrollToTopEl.classList.remove(classNameEnter);
            scrollToTopEl.classList.add(classNameLeave);
        }
    });
};
